// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lyric confirmation modal — the standard app-wide dialog style.
   Use this instead of native window.confirm/alert/prompt everywhere. */
.lyric-confirm-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10050;
  animation: lyricConfirmFade 0.15s ease-in;
}

@keyframes lyricConfirmFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.lyric-confirm-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 440px;
  width: 90%;
  overflow: hidden;
  animation: lyricConfirmSlide 0.18s ease-out;
  font-family: inherit;
}

@keyframes lyricConfirmSlide {
  from { transform: translateY(16px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.lyric-confirm-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #eceef1;
}

.lyric-confirm-brand {
  font-size: 15px;
}

.lyric-confirm-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #1f2937;
}

.lyric-confirm-body {
  padding: 18px 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
}

.lyric-confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  background: #f8fafc;
  border-top: 1px solid #eceef1;
}

.lyric-confirm-btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid transparent;
}

.lyric-confirm-btn-secondary {
  background: #fff;
  color: #374151;
  border-color: #d1d5db;
}

.lyric-confirm-btn-secondary:hover {
  background: #f3f4f6;
}

.lyric-confirm-btn-primary {
  background: #1a56db;
  color: #fff;
  border-color: #1a56db;
}

.lyric-confirm-btn-primary:hover {
  background: #1648b8;
  border-color: #1648b8;
}

.lyric-confirm-btn-danger {
  background: #b91c1c;
  color: #fff;
  border-color: #b91c1c;
}

.lyric-confirm-btn-danger:hover {
  background: #991b1b;
  border-color: #991b1b;
}

/* Type-to-confirm (GitHub-style) section for destructive actions. */
.lyric-confirm-require {
  padding: 0 20px 16px;
}

.lyric-confirm-require-label {
  display: block;
  font-size: 13px;
  color: #374151;
  margin-bottom: 6px;
}

.lyric-confirm-require-label code {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 12.5px;
  color: #b91c1c;
  font-weight: 700;
}

.lyric-confirm-require-input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.lyric-confirm-require-input:focus {
  border-color: #b91c1c;
  box-shadow: 0 0 0 3px rgba(185, 28, 28, 0.12);
}

.lyric-confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/LyricConfirm.css"],"names":[],"mappings":"AAAA;uEACuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Lyric confirmation modal — the standard app-wide dialog style.\n   Use this instead of native window.confirm/alert/prompt everywhere. */\n.lyric-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10050;\n  animation: lyricConfirmFade 0.15s ease-in;\n}\n\n@keyframes lyricConfirmFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.lyric-confirm-card {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  max-width: 440px;\n  width: 90%;\n  overflow: hidden;\n  animation: lyricConfirmSlide 0.18s ease-out;\n  font-family: inherit;\n}\n\n@keyframes lyricConfirmSlide {\n  from { transform: translateY(16px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.lyric-confirm-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #eceef1;\n}\n\n.lyric-confirm-brand {\n  font-size: 15px;\n}\n\n.lyric-confirm-header h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.lyric-confirm-body {\n  padding: 18px 20px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #374151;\n}\n\n.lyric-confirm-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  background: #f8fafc;\n  border-top: 1px solid #eceef1;\n}\n\n.lyric-confirm-btn {\n  padding: 9px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: 1px solid transparent;\n}\n\n.lyric-confirm-btn-secondary {\n  background: #fff;\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n.lyric-confirm-btn-secondary:hover {\n  background: #f3f4f6;\n}\n\n.lyric-confirm-btn-primary {\n  background: #1a56db;\n  color: #fff;\n  border-color: #1a56db;\n}\n\n.lyric-confirm-btn-primary:hover {\n  background: #1648b8;\n  border-color: #1648b8;\n}\n\n.lyric-confirm-btn-danger {\n  background: #b91c1c;\n  color: #fff;\n  border-color: #b91c1c;\n}\n\n.lyric-confirm-btn-danger:hover {\n  background: #991b1b;\n  border-color: #991b1b;\n}\n\n/* Type-to-confirm (GitHub-style) section for destructive actions. */\n.lyric-confirm-require {\n  padding: 0 20px 16px;\n}\n\n.lyric-confirm-require-label {\n  display: block;\n  font-size: 13px;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.lyric-confirm-require-label code {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-size: 12.5px;\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.lyric-confirm-require-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px;\n  font-size: 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  color: #1f2937;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.lyric-confirm-require-input:focus {\n  border-color: #b91c1c;\n  box-shadow: 0 0 0 3px rgba(185, 28, 28, 0.12);\n}\n\n.lyric-confirm-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
